module.exports = __webpack_public_path__ + "static/media/V.6671ba1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/V.jpg
// module id = 90
// module chunks = 0